import { PersonPinCircle } from '@mui/icons-material';
import { Box } from '@mui/material';
import { Marker } from 'react-map-gl/mapbox';

const UserMarker = props => {
  return (
    <Marker {...props}>
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translateX(-50%) translateY(-50%)',
          width: '20px',
          height: '20px',
          backgroundColor: 'white',
          borderRadius: '50%',
          boxShadow: '0 0 8px rgba(0, 0, 0, 0.3)',
          '&::before': {
            content: '""',
            position: 'relative',
            display: 'block',
            width: '300%',
            height: '300%',
            boxSizing: 'border-box',
            marginLeft: '-100%',
            marginTop: '-100%',
            borderRadius: '50%',
            backgroundColor: 'red',
            animation:
              'pulsateRing 3s cubic-bezier(0.215, 0.61, 0.355, 1) infinite',
            boxShadow: '0 0 8px rgba(0, 0, 0, 0.3)',
          },
          '&::after': {
            borderRadius: '50%',
            content: '""',
            width: '16px',
            height: '16px',
            backgroundColor: 'red',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
          },
          '@keyframes pulsateRing': {
            '0%': {
              transform: 'scale(.33)',
            },
            '50%, 100%': {
              opacity: 0,
            },
          },
        }}
      >
        <PersonPinCircle
          sx={{
            position: 'absolute',
            top: '-22px',
            left: '-5px',
            fontSize: '30px',
            color: 'red',
          }}
        />
      </Box>
    </Marker>
  );
};
export default UserMarker;
